var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9961 5.43286C19.9727 5.21774 19.8391 5.02735 19.6393 4.93411L10.2643 0.559111C10.0967 0.480947 9.9032 0.480947 9.73566 0.559111L0.360664 4.93411C0.160898 5.02735 0.0272266 5.2177 0.00382812 5.43286C0.00332031 5.43735 0 5.4972 0 5.50048V16.1255C0 16.381 0.155586 16.6109 0.392891 16.7058L9.76789 20.4558C9.84238 20.4856 9.92121 20.5005 10 20.5005C10.0788 20.5005 10.1576 20.4856 10.2321 20.4558L19.6071 16.7058C19.8444 16.6109 20 16.381 20 16.1255V5.50048C20 5.4972 19.9966 5.43731 19.9961 5.43286ZM10 1.81517L17.8025 5.45634L14.798 6.65813L6.84871 3.28579L10 1.81517ZM5.32461 3.99704L13.1506 7.31708L10 8.57731L2.1975 5.45634L5.32461 3.99704ZM1.25 6.4236L9.375 9.6736V18.9523L1.25 15.7023V6.4236ZM10.625 18.9524V9.6736L18.75 6.4236V15.7023L10.625 18.9524Z",
    fill: "#D4D1D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProducts);
export default __webpack_public_path__ + "static/media/iconProducts.b435c8bd6147fd07fc994432da24c958.svg";
export { ForwardRef as ReactComponent };